import { createAsyncThunk } from "@reduxjs/toolkit";
import { marketMakerApi, treasuryApi } from "../../http";
import { isNullOrEmpty, removeNullOrEmpty } from "../../utils/obj-utils";
import { RootState } from "../store";

export const getAccountBalancesActionsAction = createAsyncThunk(
  "treasury/getAccountBalances",
  async () => {
    return treasuryApi.getAccountBalances();
  }
);

export const getRwaContractBalancesAction = createAsyncThunk(
  "treasury/getRwaContractBalances",
  async () => {
    return treasuryApi.getRwaContractBalances();
  }
);

export const getTreasuryTransactionsAction = createAsyncThunk(
  "treasury/getTreasuryTxs",
  async (
    {
      page,
      filters,
    }: {
      page?: number;
      filters?: any;
    },
    thunk
  ) => {
    const category = (<RootState>thunk.getState()).treasury
      .selectedTransactionsCategory;
    const pageSize = (<RootState>thunk.getState()).treasury
      .transactionsCategoriesPageSizes[category];
    const payload = await treasuryApi.getTreasuryTxs(category, {
      from: page && pageSize ? page * pageSize : 0,
      take: pageSize,
      filters: isNullOrEmpty(filters)
        ? undefined
        : JSON.stringify(removeNullOrEmpty(filters)),
    });

    return { category, payload };
  }
);

export const getMmOrderBookAction = createAsyncThunk(
  "treasury/getMmOrderBook",
  async (token: string) => {
    const orderBook = await marketMakerApi.getOrderBook(token);
    return {
      token,
      orderBook: {
        buy: orderBook.buy.map((order) => {
          return {
            ...order,
            total: order.amount * order.price,
          };
        }),
        sell: orderBook.sell.map((order) => {
          return {
            ...order,
            total: order.amount * Number(order.price),
          };
        }),
      },
    };
  }
);

export const getMmLatestTradesAction = createAsyncThunk(
  "treasury/getMmLatestTrades",
  async (token: string, thunk) => {
    const params = (<RootState>thunk.getState()).treasury.mmLatestTradesParams[
      token
    ];

    const latestTrades = await marketMakerApi.getLatestTrades(
      token,
      params?.nonMmTrade
    );
    return { token, latestTrades };
  }
);

export const changeMmLatestTradesParamsAction = createAsyncThunk(
  "treasury/changeMmLatestTradesParams",
  async (
    { token, params }: { token: string; params: { nonMmTrade: boolean } },
    thunk
  ) => {
    thunk.dispatch(getMmLatestTradesAction(token));
  }
);
